import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/legal")({
  head: () => ({ meta: [{ title: "Legal Pages | Admin" }] }),
  component: lazyRouteComponent(() => import("@/pages-lazy/admin-legal")),
});
